type BlockHoursInfo = (arg: { color?: string }) => any

const DEFAULT_COLOR_GRAY = 'rgb(248, 249, 251)'

export const useReactBlockHoursStyles: BlockHoursInfo = ({
  color = DEFAULT_COLOR_GRAY
}) => ({
  backgroundColor: color,
  borderRadius: 10,
  border: color === DEFAULT_COLOR_GRAY ? '1px #dbdff1 solid' : null,
  content: '" "',
  display: 'block',
  margin: '1px 8px 1px 0',
  height: 15,
  minWidth: 15
})
